export const USERFLOW_DOWNLOAD_MOBILE_APP_ID = '4a181817-054c-4970-a077-4bfbd8f2dde1'
export const USERFLOW_INVOICE_GUIDE_ID = '11619a37-0249-4d9d-aec5-50e6b1e2afb6'
export const USERFLOW_ONBOARDING_CHECKLIST_ID = '339c0f2f-8fec-4ae3-a58f-374d331b5aba'
export const USERFLOW_SETTINGS_GUIDE_ID = '3c4dfc2a-1c93-42d5-a84a-9136a7b5ed0e'
export const USERFLOW_SCOUT_ONBOARDING_ID = '7173e21c-2373-4fcc-b5f2-deb416a5d08b'
